var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.2328 7.14824C4.19336 7.10982 4.02472 6.96475 3.886 6.82962C3.01356 6.03737 1.58556 3.97064 1.14968 2.88891C1.07964 2.72463 0.931395 2.3093 0.921875 2.08739C0.921875 1.87476 0.970835 1.67206 1.07012 1.47863C1.20884 1.23751 1.42711 1.04409 1.68484 0.938103C1.86367 0.869874 2.39884 0.763888 2.40836 0.763888C2.99384 0.657902 3.94516 0.599609 4.99644 0.599609C5.99808 0.599609 6.91063 0.657902 7.50495 0.744678C7.51447 0.754614 8.17952 0.860601 8.40732 0.976523C8.82348 1.18916 9.08187 1.60449 9.08187 2.04897V2.08739C9.07168 2.37687 8.81327 2.98563 8.80375 2.98563C8.36719 4.00906 7.00923 6.0281 6.10687 6.83955C6.10687 6.83955 5.875 7.06809 5.73015 7.16745C5.52208 7.32245 5.26436 7.39929 5.00664 7.39929C4.719 7.39929 4.45108 7.31252 4.2328 7.14824Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBold);
export default __webpack_public_path__ + "static/media/arrow_down_bold.8ed845b48752d0c5b3f305ecb4309bda.svg";
export { ForwardRef as ReactComponent };